import { useSelector } from "react-redux";
import { instance as axiosToken, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance";
import { instance as axios } from "../../config/axiosInstance";
// const { selectedSite } = useSelector((state) => (state?.selectedSite))
// ---------user-Profile-Api-----------------------
export const userProfileApi = async (data) => {
    const endPoint = `user/profile/details` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};
// ---------edit-Profile-Api-----------------------
export const editProfileApi = async (data) => {
    return await axios.put(`user/profile/update-image`, data, setMultiPartHeader());
};

// ---------delete-Account-Api-----------------------
export const deleteAccountApi = async (data) => {
    return await axios.delete(`user/setting/account-delete`, data, setMultiPartHeader());
};

// -------------------------contact-Us-Api-------------------------
export const contactUsApi = async (data) => {
    return await axios.post(`user/support/submit`, data, setJwtToken());
};
